(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('SocialInsuranceDeleteController',SocialInsuranceDeleteController);

    SocialInsuranceDeleteController.$inject = ['$uibModalInstance', 'entity', 'SocialInsurance'];

    function SocialInsuranceDeleteController($uibModalInstance, entity, SocialInsurance) {
        var vm = this;
        vm.socialInsurance = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            SocialInsurance.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
